import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import styles from './WorkComp.module.css';
import { DBDateField, DBDropDown, DBTextField } from '_components';
import { PatientCareCenterNoteSubjectivePDCSelector } from './PDCSelector';


class PatientCareCenterNoteSubjectiveWorkComp extends React.Component {

    handleBodyPartChange(event) {
        let tpno = parseInt(event.target.value);
        let odgOptions = Object.keys(this.props.odgXref)
            .filter(key => {
                return (this.props.odgXref[key].EOXTPNO === tpno);
            })
            .map(key => this.props.odgXref[key].EOXODNO);

        if (odgOptions.length === 0) {
            this.props.clearField(this.props.noteId, 'PTEVAL', 'EVNO', this.props.evno, 'EVSUBWCODG');
        } else if (odgOptions.length === 1) {
            this.props.updateIntField(this.props.noteId, 'PTEVAL', 'EVNO', this.props.evno, 'EVSUBWCODG', odgOptions[0]);
        }
    }


    render() {
        if (this.props.isWc && this.props.noteType === 1) {
            return (
                <PatientCareCenterNoteSection id='subj_wc' name='Work Comp' level={1}>
                    <div className={styles.row}>
                        <label className={styles.narrow_col}>Employer:</label>
                        <span className={styles.leftover_col}>{this.props.employer}</span>
                    </div>
                    <div className={styles.row} id='subj_wc_occupation'>
                        <label className={styles.narrow_col_req}>Occupation:</label>
                        <span className={styles.leftover_col}>
                            {this.props.occupations !== undefined &&
                                <DBDropDown
                                    className={styles.drop_down}
                                    noteId={this.props.noteId}
                                    entity='PTEVAL'
                                    entityKeyColumn='EVNO'
                                    entityKeyValue={this.props.evno}
                                    field='EVSUBWCOCCUPATION'
                                    customOptions={this.props.occupations}
                                />
                            }
                            {this.props.occupations === undefined &&
                                <DBTextField
                                    className={styles.drop_down}
                                    noteId={this.props.noteId}
                                    entity='PTEVAL'
                                    entityKeyColumn='EVNO'
                                    entityKeyValue={this.props.evno}
                                    field='EVSUBWCOCCUPATION'
                                />
                            }
                        </span>
                    </div>
                    <div className={styles.row} id='subj_wc_status'>
                        <label className={styles.narrow_col_req}>Status:</label>
                        <span className={styles.leftover_col}>
                            <DBDropDown
                                className={styles.drop_down}
                                noteId={this.props.noteId}
                                entity='PTEVAL'
                                entityKeyColumn='EVNO'
                                entityKeyValue={this.props.evno}
                                field='EVSUBWCSTATUS'
                                masterEntity='PTMASTERWCSTATUS'
                                masterEntityKeyColumn='WSNO'
                                masterEntitySort='WSORDER'
                                masterEntityDisplay='WSNAME'
                            />
                        </span>
                    </div>
                    <div className={styles.row}>
                        <label className={styles.narrow_col}>Last Day:</label>
                        <span className={styles.leftover_col}>
                            <DBDateField
                                noteId={this.props.noteId}
                                entity='PTEVAL'
                                entityKeyColumn='EVNO'
                                entityKeyValue={this.props.evno}
                                maxDate={new Date()}
                                field='EVSUBWCLASTDAY'
                            />
                        </span>
                    </div>

                    <PatientCareCenterNoteSubjectivePDCSelector />

                    <PatientCareCenterNoteSection id='subj_wc_odg' name='ODG Analysis' level={2} allowCollapse={false} >
                        <div className={styles.row}>
                            <label className={styles.wide_col_req}>Body Part Affected:</label>
                            <span className={styles.leftover_col}>
                                <DBDropDown
                                    className={styles.drop_down}
                                    noteId={this.props.noteId}
                                    entity='PTEVAL'
                                    entityKeyColumn='EVNO'
                                    entityKeyValue={this.props.evno}
                                    field='EVSUBWCBODYPART'
                                    masterEntity='CWEVALTYPES'
                                    masterEntityKeyColumn='TPNO'
                                    masterEntitySort='TPTITLE'
                                    masterEntityDisplay='TPTITLE'
                                    onChange={event => this.handleBodyPartChange(event)}
                                />
                            </span>
                        </div>

                        {this.props.odgDetails && this.props.odgDetails.length > 1 &&
                            <div className={styles.row}>
                                <label className={styles.wide_col_req}>Specific condition:</label>
                                <span className={styles.leftover_col}>
                                    <DBDropDown
                                        className={styles.drop_down}
                                        noteId={this.props.noteId}
                                        entity='PTEVAL'
                                        entityKeyColumn='EVNO'
                                        entityKeyValue={this.props.evno}
                                        field='EVSUBWCODG'
                                        customOptions={this.props.odgDetails}
                                    />
                                </span>
                            </div>
                        }

                    </PatientCareCenterNoteSection>

                </PatientCareCenterNoteSection>
            );
        }
        else if (this.props.isWc && this.props.noteType !== 1) {
            return (
                    <PatientCareCenterNoteSection id='subj_wc' name='Work Comp' level={1}>
                    <div className={styles.row} id='subj_wc_status'>
                        <label className={this.props.noteType === 4 ? styles.narrow_col : styles.narrow_col_req}>Status:</label>
                        <span className={styles.leftover_col}>
                            <DBDropDown
                                className={styles.drop_down}
                                noteId={this.props.noteId}
                                entity='PTNOTE'
                                entityKeyColumn='NTNO'
                                entityKeyValue={this.props.pk}
                                field='NTSUBWCSTATUS'
                                masterEntity='PTMASTERWCSTATUS'
                                masterEntityKeyColumn='WSNO'
                                masterEntitySort='WSORDER'
                                masterEntityDisplay='WSNAME'
                            />
                        </span>
                    </div>
                        <PatientCareCenterNoteSubjectivePDCSelector />
                    </PatientCareCenterNoteSection>
            );
        }
        else {
            return (<span />);
        }
    }

}


function mapDispatchToProps(dispatch) {
    return {
        updateIntField: bindActionCreators(noteActions.updateIntField, dispatch),
        clearField: bindActionCreators(noteActions.clearField, dispatch),
        clearGoals: bindActionCreators(noteActions.clearGoals, dispatch)
    };
}


function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let evno = parseInt(noteId.split("_")[1]);
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;

    let occupations = undefined;
    if (state.entities.admissions[epno].isMdcps === true) {
        occupations = Object.keys(state.entities.masterData.FNJOBTITLES)
            .filter(key => {
                return (state.entities.masterData.FNJOBTITLES[key].JTMDCPS === true);
            })
            .sort((a, b) => {
                return state.entities.masterData.FNJOBTITLES[a].JTNAME > state.entities.masterData.FNJOBTITLES[b].JTNAME ? 1 : -1;
            })
            .map(key => { return { id: state.entities.masterData.FNJOBTITLES[key].JTNAME, value: state.entities.masterData.FNJOBTITLES[key].JTNAME } })
    }

    let odgDetails = undefined;
    if (noteType === 1 && state.entities.notes.PTEVAL[evno].EVSUBWCBODYPART !== null) {
        let odnos = Object.keys(state.entities.masterData.CWEVALTYPESODGDETAILSXREF)
            .filter(key => {
                return (state.entities.masterData.CWEVALTYPESODGDETAILSXREF[key].EOXTPNO === state.entities.notes.PTEVAL[evno].EVSUBWCBODYPART);
            })
            .map(key => state.entities.masterData.CWEVALTYPESODGDETAILSXREF[key].EOXODNO);

        odgDetails = Object.keys(state.entities.masterData.CWODGDETAILS)
            .filter(key => {
                return (odnos.includes(state.entities.masterData.CWODGDETAILS[key].ODNO));
            })
            .sort((a, b) => {
                return state.entities.masterData.CWODGDETAILS[a].ODNAME > state.entities.masterData.CWODGDETAILS[b].ODNAME ? 1 : -1;
            })
            .map(key => {
                return { id: state.entities.masterData.CWODGDETAILS[key].ODNO, value: state.entities.masterData.CWODGDETAILS[key].ODNAME }
            });
    }

    let goalCount = Object.keys(state.entities.notes.PTGOALS)
        .filter(key => {
            return ((noteType === 1 && state.entities.notes.PTGOALS[key].GOEVNO === pk) ||
                (noteType !== 1 && state.entities.notes.PTGOALS[key].GONTNO === pk)) &&
                state.entities.notes.PTGOALS[key].GODELETED !== true
        })
        .map(key => state.entities.notes.PTGOALS[key]).length;

    let employer = Object.keys(state.entities.insured)
        .filter(key => {
            return (state.entities.insured[key].epno === epno
                && state.entities.insured[key].position === 1)
        })
        .map(key => state.entities.insured[key]);



    return {
        noteId: noteId,
        evno: evno,
        noteType,
        employer: employer && employer[0] ? employer[0].employerName : undefined,
        occupations: occupations,
        odgDetails: odgDetails,
        odgXref: state.entities.masterData.CWEVALTYPESODGDETAILSXREF,
        isWc: state.entities.admissions[epno].isWc,
        goalCount: goalCount,
        pk
    };
}

const connectedPatientCareCenterNoteSubjectiveWorkComp = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteSubjectiveWorkComp);
export { connectedPatientCareCenterNoteSubjectiveWorkComp as PatientCareCenterNoteSubjectiveWorkComp };

